import { IFunnelStageRepository } from '../../../domain/repositories/IFunnelStageRepository';
import { FunnelStage } from '../../../types';

export class GetFunnelStagesUseCase {
    constructor(private funnelStageRepository: IFunnelStageRepository) { }

    async execute(funnelId?: string): Promise<FunnelStage[]> {
        return await this.funnelStageRepository.findAll(funnelId);
    }
}
